import { Color } from '@shared/enums';

export const defaultBreadcrumbConfig = {
  color: 'BLACK' as keyof typeof Color,
};
